/**
 * StockPortalService
 * Service for vendor portal stock management endpoints in VendorCatalogManagement
 * Route: api/portal/vendor/events
 * Controller: VendorStockPortalController.cs (CCMS.Api.VendorCatalogManagement)
 */
import { BaseService } from '../base/BaseService';
/**
 * StockPortalService
 * Vendor portal endpoints for managing stock levels at events.
 * Requires vendor authentication.
 */
export class StockPortalService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StockPortalService.DEFAULT_SERVICE_PATH,
            basePath: StockPortalService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== READ ====================
    /**
     * Get vendor's products stock at an event
     * GET /api/portal/vendor/events/{eventId}/stock
     */
    async getVendorEventStock(eventId) {
        const response = await this.getVendorEventStockRaw(eventId);
        return response.data ?? [];
    }
    /**
     * Get vendor event stock (raw response)
     */
    getVendorEventStockRaw(eventId) {
        const endpoint = this.getEndpoint('vendor-event-stock', `${eventId}/stock`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== SET STOCK ====================
    /**
     * Set product stock levels at an event
     * PUT /api/portal/vendor/events/{eventId}/products/{productId}/stock
     */
    async setProductStock(eventId, productId, request) {
        const endpoint = this.getEndpoint('set-product-stock', `${eventId}/products/${productId}/stock`);
        const url = this.buildUrl(endpoint);
        await this.http.put(url, request);
    }
    /**
     * Set variant stock levels at an event
     * PUT /api/portal/vendor/events/{eventId}/variants/{variantId}/stock
     */
    async setVariantStock(eventId, variantId, request) {
        const endpoint = this.getEndpoint('set-variant-stock', `${eventId}/variants/${variantId}/stock`);
        const url = this.buildUrl(endpoint);
        await this.http.put(url, request);
    }
    /**
     * Set add-on stock levels at an event
     * PUT /api/portal/vendor/events/{eventId}/addons/{addOnId}/stock
     */
    async setAddOnStock(eventId, addOnId, request) {
        const endpoint = this.getEndpoint('set-addon-stock', `${eventId}/addons/${addOnId}/stock`);
        const url = this.buildUrl(endpoint);
        await this.http.put(url, request);
    }
    // ==================== BULK ====================
    /**
     * Bulk-set stock for an event (products, variants, add-ons in one call)
     * POST /api/portal/vendor/events/{eventId}/stock/bulk
     */
    async setBulkStock(eventId, request) {
        const endpoint = this.getEndpoint('bulk-set-stock', `${eventId}/stock/bulk`);
        const url = this.buildUrl(endpoint);
        await this.http.post(url, request);
    }
}
StockPortalService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
StockPortalService.BASE_PATH = 'api/portal/vendor/events';
//# sourceMappingURL=StockPortalService.js.map